import React, { useState } from "react";
import jsPDF from "jspdf";
import "../styles/pageStyles/ImageToPdf.scss"

const ImageToPdf = () => {
    const [images, setImages] = useState([]);

    const handleImageUpload = (event) => {
        const files = event.target.files;
        setImages([...images, ...files]);
    };

    const convertImagesToPDF = () => {
        const doc = new jsPDF();
        const imagePromises = [];

        images.forEach((image, index) => {
            const reader = new FileReader();
            reader.onload = () => {
                const imgData = reader.result;
                const img = new Image();
                img.onload = () => {
                    const width = 210; // A4 width in mm
                    const height = (width * img.height) / img.width; // maintain aspect ratio
                    doc.addImage(imgData, "PNG", 0, 100, width, height);
                    if (index < images.length - 1) {
                        doc.addPage();
                    } else {
                        doc.save("images.pdf");
                    }
                };
                img.src = imgData;
            };
            reader.readAsDataURL(image);
            imagePromises.push(new Promise((resolve) => reader.onloadend = resolve));
        });

        Promise.all(imagePromises).then(() => {
            // No need to save here, it's done after the last image is added
        });
    };

    return (
        <div className="image-to-pdf">
            <h2>Convert Image To PDF</h2>
            <div className="image-to-pdf__button-container">
                <input type="file" multiple onChange={handleImageUpload} />
                <button onClick={convertImagesToPDF}>Convert to PDF and Download</button>
            </div>

        </div>
    );
};

export default ImageToPdf;
